<div class="avm-container">
    <mat-dialog-content>
        <div *ngIf="data?.isValuationEstimate" class="title"><strong>AVM</strong></div>
        <div *ngIf="data?.isValuationEstimateOwner" class="title"><strong>Automated Valuation Model (AVM)</strong></div>
        <div *ngIf="data?.isValuationHistory" class="title"><strong>Valuation Trend History</strong>
        </div>
        <p *ngIf="data?.isValuationEstimate">AVM (Automated Valuation Model) is a technology-driven method used to
            estimate the
            value of a property. AVMs utilize
            mathematical algorithms and statistical models to analyze various data points, such as recent sales prices
            of comparable
            properties, local market trends, property characteristics, and other relevant factors.
            <br><br>
            The purpose of an AVM is to provide a quick and objective estimate of a property's value without requiring a
            physical
            appraisal. However, it's important to note that AVMs are not always as accurate as a professional appraisal
            and should
            be used as a starting point for property valuation rather than a definitive assessment.
        </p>
        <p *ngIf="data?.isValuationHistory">Valuation trend history in real estate is a tool or metric used to track
            changes
            in property values over time. It helps
            professionals and investors analyze market conditions and forecast future trends.
            <br><br>

            <span *ngIf="isManuallyAdjusted; else noAdjustmentMessage">
                This value was manually adjusted in HomeDashboard to reflect a
                {{marketValueHistory?.propertyAdjustments?.adjustmentValue | number : '1.0-1'}} percent value change as
                of
                {{marketValueHistory?.propertyAdjustments?.updatedTimestamp | date:'MM-dd-yy'}}.
                This adjustment is factored into the value you see in your dashboard.
            </span>
            <ng-template #noAdjustmentMessage>
                These values come from an AVM (Automated Valuation Model) method, utilizing mathematical algorithms and
                statistical
                models to analyze various data points to determine the value of a particular property.
            </ng-template>

            <br><br>

            While this can be used as a tool, it’s important to note that AVMs are not always as accurate as a
            professional
            appraisal and should be used as a starting point for property valuation rather than a definitive assessment.
        </p>
        <div *ngIf="data?.isValuationEstimateOwner">
            AVM is a technology-driven tool that uses mathematical algorithms or statistical models to calculate real
            estate values.
            <br><br>
            <span *ngIf="isManuallyAdjusted; else noAdjustmentMessage">
                This value was manually adjusted in HomeDashboard to reflect a
                {{marketValueHistory?.propertyAdjustments?.adjustmentValue | number : '1.0-1'}} percent value change as
                of
                {{marketValueHistory?.propertyAdjustments?.updatedTimestamp | date:'MM-dd-yy'}}.
                This adjustment is factored into the value you see in your dashboard.
            </span>
            <ng-template #noAdjustmentMessage>
                This estimate doesn't include values for any improvements you may have done since you purchased your
                home. You can adjust your home value to account for any major changes.
            </ng-template>
            <br><br>

            <strong>Low AVM:</strong> {{marketValueHistory?.lowValue | number : '1.0-0'}}
            <br>
            <strong>Current AVM:</strong> {{marketValueHistory?.estimatedValue | number : '1.0-0'}}
            <br>
            <strong>High AVM:</strong> {{marketValueHistory?.highValue | number : '1.0-0'}}
            <br>
            <strong>Processed date:</strong> {{marketValueHistory?.processedDate | date:'MM-dd-yy'}}
            <br>
            <strong>Data Provider:</strong> {{marketValueHistory?.source}}
            <br>

            <br>
            An AVM can provide a quick and objective estimate of a property's value without requiring a physical
            appraisal. It’s important to note that AVMs are not always as accurate as a professional appraisal.

            <br><br>
            <span *ngIf="isManuallyAdjusted">Manually adjusted value:
                {{marketValueHistory?.propertyAdjustments?.adjustmentValue | number : '1.0-1'}}%</span>

            <br>
            <span *ngIf="isManuallyAdjusted">Date adjusted: {{marketValueHistory?.propertyAdjustments?.updatedTimestamp
                | date:'MM-dd-yy'}}</span>
            <br>
            <span *ngIf="isManuallyAdjusted">Reason:
                {{marketValueHistory?.propertyAdjustments?.avmAdjustmentReason?.name}}</span>

        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="mb-1 float-end">
        <button mat-button (click)="onNoClick()">Close</button>
        <button class="btn btn-secondary" *ngIf="data?.isValuationEstimateOwner" mat-button
            (click)="onAdjustHomeValue()">Adjust Home Value</button>
    </mat-dialog-actions>
</div>